import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AppCtx = createContext(null);

export const AppProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => localStorage.getItem("lang") || null);
  const [category, setCategory] = useState(null);
  const [originalText, setOriginalText] = useState("");
  const [refinedText, setRefinedText] = useState("");
  const [attachments, setAttachments] = useState([]); // [{id, filename, content_type, size}]
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  useEffect(() => {
    if (language) {
      localStorage.setItem("lang", language);
      document.documentElement.dir = language === "ar" ? "rtl" : "ltr";
      document.documentElement.lang = language;
    }
  }, [language]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setAuthLoading(false);
      return;
    }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("token"))
      .finally(() => setAuthLoading(false));
  }, []);

  const login = (token, u) => {
    localStorage.setItem("token", token);
    setUser(u);
  };
  const logout = () => {
    localStorage.removeItem("token");
    setUser(null);
  };
  const resetWizard = () => {
    setCategory(null);
    setOriginalText("");
    setRefinedText("");
    setAttachments([]);
  };

  return (
    <AppCtx.Provider
      value={{
        language,
        setLanguage,
        category,
        setCategory,
        originalText,
        setOriginalText,
        refinedText,
        setRefinedText,
        attachments,
        setAttachments,
        user,
        authLoading,
        login,
        logout,
        resetWizard,
      }}
    >
      {children}
    </AppCtx.Provider>
  );
};

export const useApp = () => useContext(AppCtx);
